import { Popup } from '@progress/kendo-react-popup';
import ClickOutside from 'app/widgets/ClickOutside';
import clsx from 'clsx';
import React, { useEffect, useMemo } from 'react';
import { ActionsListItem } from './types';
import './Menu.less';

interface Props {
  anchorEl?: HTMLElement;
  actions: ActionsListItem[];
  onClose: () => void;
  menuClassName?: string;
}

export default function Menu({
  anchorEl,
  actions,
  onClose,
  menuClassName,
}: Props) {
  const menuOpen = Boolean(anchorEl);

  const activeActions = useMemo(
    () => actions.filter(({ exclude }) => !exclude),
    [actions],
  );

  useEffect(() => {
    if (menuOpen) {
      window.addEventListener('scroll', onClose, true);
    }

    return () => {
      window.removeEventListener('scroll', onClose, true);
    };
  }, [menuOpen, onClose]);

  return (
    <Popup
      anchor={anchorEl}
      show={menuOpen}
      popupAlign={{ horizontal: 'right', vertical: 'top' }}
    >
      <ClickOutside
        onClickOutside={event => {
          if (
            anchorEl &&
            (event.target === anchorEl ||
              anchorEl.contains(event.target as Node))
          ) {
            return;
          }

          onClose();
        }}
      >
        <ul className={clsx('base-menu__list', menuClassName)}>
          {activeActions.map(({ label, action, disabled }, index) => (
            <li
              key={`${label}-${index}`}
              className={clsx('base-menu__item', {
                'base-menu__item_disabled': disabled,
              })}
              onClick={event => {
                event.stopPropagation();

                if (!disabled) {
                  action();
                  onClose();
                }
              }}
            >
              {label}
            </li>
          ))}
        </ul>
      </ClickOutside>
    </Popup>
  );
}
